import SectionHeading from "@/components/feature/SectionHeading";
import { hotRankItems, statItems } from "@/mocks/home";

const screenBarWidths = [92, 78, 64];

export default function HotRanking() {
  const screening = hotRankItems.slice(0, 3);

  return (
    <section id="ranking" className="w-full bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="正在刷屏"
          title="今日热传榜"
          description="按当下的转发与讨论热度实时排位。名次会随新内容补档变动，前三条基本就是今天最出圈的那几段。"
          action={
            <a
              href="#latest"
              className="inline-flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-refresh-line"></i>
              查看全部更新
            </a>
          }
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3 md:mt-10">
          <div className="lg:col-span-2">
            <ol className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {hotRankItems.map((item) => (
                <li
                  key={item.rank}
                  className="flex gap-4 border-b border-background-200 px-4 py-4 last:border-b-0 md:px-6"
                >
                  <span
                    className={
                      item.rank <= 3
                        ? "flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-bold text-background-50"
                        : "flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-200 font-heading text-base font-bold text-foreground-600"
                    }
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <a href="#latest" className="group block">
                      <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors line-clamp-2 group-hover:text-primary-600 md:text-base">
                        {item.title}
                      </h3>
                      <p className="mt-1 hidden text-xs text-foreground-500 sm:block line-clamp-1">
                        {item.summary}
                      </p>
                    </a>
                    <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span className="whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-900">
                        {item.tag}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-chat-3-line text-sm"></i>
                        {item.comments}
                      </span>
                      <span className="whitespace-nowrap">{item.time}</span>
                    </div>
                  </div>
                  <div className="hidden shrink-0 flex-col items-end justify-center md:flex">
                    <span className="font-heading text-lg font-bold text-accent-600">
                      {item.heat}
                    </span>
                    <span className="text-xs text-foreground-400">热度值</span>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <aside id="board" className="lg:col-span-1">
            <div className="flex flex-col gap-6">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    刷屏榜 · 今日数据
                  </h3>
                  <span className="flex items-center gap-1 text-xs text-primary-600">
                    <span className="h-1.5 w-1.5 animate-live-dot rounded-full bg-primary-500"></span>
                    实时
                  </span>
                </div>

                <div className="mt-5 space-y-4">
                  {screening.map((item, index) => (
                    <div key={item.rank}>
                      <div className="flex items-center justify-between gap-3 text-xs">
                        <span className="truncate text-foreground-700">{item.title}</span>
                        <span className="shrink-0 font-medium text-foreground-500">
                          {item.heat}
                        </span>
                      </div>
                      <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                        <span
                          className="block h-full rounded-full bg-accent-500"
                          style={{ width: `${screenBarWidths[index]}%` }}
                        ></span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-6 grid grid-cols-2 gap-px overflow-hidden rounded-md border border-background-200 bg-background-200">
                  {statItems.map((stat) => (
                    <div key={stat.id} className="bg-background-50 px-4 py-3.5">
                      <p className="font-heading text-xl font-bold text-foreground-950">
                        {stat.value}
                        <span className="ml-0.5 text-xs font-normal text-foreground-500">
                          {stat.unit}
                        </span>
                      </p>
                      <p className="mt-0.5 text-xs text-foreground-600">{stat.label}</p>
                      <p className="mt-1 text-[11px] text-primary-600">{stat.delta}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
                <div className="flex items-center gap-2 text-primary-700">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className="ri-notification-3-line"></i>
                  </span>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    刷屏一出现就补
                  </h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                  盯住最新状态，省得自己到处翻。新出的更新会按时间补进来，随时可以回看刚出画面和当场动向。
                </p>
                <a
                  href="#subscribe"
                  className="mt-4 inline-flex h-10 w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-add-line"></i>
                  订阅更新提醒
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}